import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnType } from "../common/common.model";

export interface INotificationEventEndpointHttpResponse {
    id: number,
    title: string;
    notificationEventEndPointType: number;
    notificationEventEndPointTypeName: string;
}

export class NotificationEventEndpoint {
    public notificationEventId!: number;
    constructor(
        public id: number,
        public title: string,
        public notificationEventEndPointType: number,
        public notificationEventEndPointTypeName: string
    ) { }

    public static adapt(data: INotificationEventEndpointHttpResponse) {
        return new this(
            data.id,
            data.title,
            data.notificationEventEndPointType,
            data.notificationEventEndPointTypeName
        );
    }

    public static createBlank() {
        return new this(0, '', 0, '');
    }
}

export const NotificationEventEndpointColumns: Readonly<EvideTableColumn[]> = [
    {
        key: 'title',
        type: EvideTableColumnType.String,
        title: 'Title',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'notificationEventEndPointTypeName',
        type: EvideTableColumnType.String,
        title: 'Endpoint Type',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'options',
        type: EvideTableColumnType.Options,
        matIcon: 'more_vert',
        title: 'Options',
        optionMenu: [
            {
                key: 'edit',
                type: EvideTableColumnType.Action,
                matIcon: 'fa fa-fw fa-pen',
                title: 'Edit',
                accessVisibility: {
                    controllerKey: EAccess.NotificationEventEndpoint,
                    methodKey: EAccessMethod.Put
                }
            },
            {
                key: 'delete',
                type: EvideTableColumnType.Action,
                matIcon: 'fa fa-fw fa-trash-alt',
                title: 'Delete',
                accessVisibility: {
                    controllerKey: EAccess.NotificationEventEndpoint,
                    methodKey: EAccessMethod.Delete
                }
            }
        ]
    }
];

export interface INotificationDynamicButtonHttpResponse {
    notificationRuleId: number;
    buttonName: string;
    btnId?: string;
}

export interface INotificationDynamicLinkHttpResponse {
    notificationRuleId: number;
    linkName: string;
}